import { Component, inject } from '@angular/core';
import { AppConfigService } from '@core/services/config/app-config.service';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';

// courier-switcher.component.ts
export interface Courier {
    id: string;
    name: string;
    img: string;
    route?: string;
    url: string;
}

@Component({
    selector: 'app-couriers-logos',
    imports: [TranslatePipe],
    templateUrl: './couriers-logos.component.html',
    styleUrl: './couriers-logos.component.scss'
})


export class CouriersLogosComponent {

    // ==========================================
    // SERVICES
    // ==========================================
    appConfig = inject(AppConfigService);


    

    private createCourierConfig(id: string, name: string, url: string) {
        return {
            id,
            name,
            img: `${this.appConfig.imagePathCouriers()}${id}.webp`,
            url: url || '#' // placeholder per ora
        };
    }

    couriers: Courier[] = [
        this.createCourierConfig('FEDEX',       'FedEx',         'https://www.fedex.com'),
        this.createCourierConfig('DPD',         'DPD',           'https://www.dpd.com'),
        this.createCourierConfig('CHRONOPOST',  'Chronopost',    'https://www.chronopost.fr'),
        this.createCourierConfig('BRT',         'Bartolini BRT', 'https://www.brt.it'),
        this.createCourierConfig('TNT',         'TNT',           'https://www.tnt.com'),
        this.createCourierConfig('EUROEXPRESS', 'Euroexpress',   'https://www.brt.it'),
        this.createCourierConfig('DHL',         'DHL Express',   'https://www.dhl.com'),
    ];



}
